import { fetchWrapper } from '../_helpers';
import { cookieHelper } from '../_helpers/cookie-helper';

const baseUrl = process.env.REACT_APP_USER_MANAGER;

export const sessionService = {
    create,
    login,
    delete: _delete,
    refresh: refresh,
};

function create(params) {
    return fetchWrapper.post(`${baseUrl}/auth/token`, params);
}

function login(params){
    return fetchWrapper.post(`${baseUrl}/client/auth`, params, true);
}

// prefixed with underscored because delete is a reserved word in javascript
async function _delete() {
    let refresh_token = cookieHelper.getRefreshToken();
    let resp = await fetchWrapper.post(`${baseUrl}/logout`, {'refresh_token': refresh_token}).catch(()=>{
        return new Response(JSON.stringify({ errors: ['Failed to logout...'] }), {
            status: 500,
            headers: { 'Content-Type': 'application/json' }
        });
    });
    cookieHelper.deleteAllCookies();
    sessionStorage.clear()
    return resp;
}

async function refresh() {
    let refresh_token = cookieHelper.getRefreshToken();
    let success = await fetchWrapper.post(`${baseUrl}/auth/refresh`, {'refresh_token': refresh_token}, true)
    .then((resp) => {
        return resp;
    }).catch(() => {
        return false;
    });
    if (success) {
        cookieHelper.setAuthCookie(success.id_token);
        if(!!success.refresh_token){
            cookieHelper.setRefreshCookie(success.refresh_token);
        }
    }
    return success;
}
